import { gql } from 'apollo-boost';

export const GET_REPORT_BY_PUBLISHER = gql`
query paymentReceiptById($publisherId: String!) {
  paymentReceiptById(publisherId: $publisherId) {
    publisherId
    paymentDate
    paymentValue
    receiptLocation
    referenceDate
    USDValue
    }
  }
`;

export const GET_REPORT_BY_PUBLISHER_REF_DATE = gql`
query paymentReceiptByIdAndRefDate($publisherId: String!, $referenceDate: String!) {
  paymentReceiptByIdAndRefDate(publisherId: $publisherId, referenceDate: $referenceDate) {
    publisherId
    paymentDate
    paymentValue
    receiptLocation
    referenceDate
    USDValue
    }
  }
`;

export const ADD = gql`
  mutation createPaymentReceipt($publisherId: String!, $paymentDate: DateTime!, $paymentValue: Float!, $USDValue: Float!, $receiptLocation: String!, $referenceDate: String!) {
    createPaymentReceipt(input: { publisherId: $publisherId, paymentDate: $paymentDate, paymentValue: $paymentValue, USDValue: $USDValue, receiptLocation: $receiptLocation, referenceDate: $referenceDate}) {
      publisherId
      paymentDate
      paymentValue
      receiptLocation
      referenceDate
      USDValue
    }
  }
`;

export const EDIT = gql`
  mutation updatePaymentReceipt($publisherId: String!, $paymentDate: DateTime!, $paymentValue: Float!, $USDValue: Float!, $receiptLocation: String!, $referenceDate: String!) {
    updatePaymentReceipt(publisherId: $publisherId, referenceDate: $referenceDate, 
    input: { publisherId: $publisherId, referenceDate: $referenceDate, paymentDate: $paymentDate, paymentValue: $paymentValue, USDValue: $USDValue, receiptLocation: $receiptLocation}) {
      publisherId
      paymentDate
      paymentValue
      receiptLocation
      referenceDate
      USDValue
    }
  }
`;